var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.5946 0.561767C3.79417 0.285238 4.20592 0.285238 4.40549 0.561767L7.75816 5.20737C7.99681 5.53805 7.76052 5.99997 7.35272 5.99997H0.647372C0.239568 5.99997 0.00327988 5.53805 0.241929 5.20737L3.5946 0.561767Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M3.00004 3.99997H5.00004V10.5C5.00004 10.7761 4.77619 11 4.50004 11H3.50004C3.2239 11 3.00004 10.7761 3.00004 10.5V3.99997Z","fill":"currentColor","key":1})]);
}

ArrowUp.defaultProps = {"width":"8","height":"11","viewBox":"0 0 8 11","fill":"currentColor"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
